import { Box, Button, Card, CardContent, Checkbox, Drawer, FormControl, FormControlLabel, FormHelperText, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import PageHeader from "../../materio/@core/components/page-header";
import { PermissionModule, RolePermission } from "../../types/common";
import InformationOutline from 'mdi-material-ui/InformationOutline'
import { ReactNode, useEffect, useMemo, useState } from "react";
import { cloneDeep, forEach, isEmpty } from "lodash";
import { client } from "../../utils/axios-client";
import { rolePermissionsEndpoint, saveRoleEndpoint } from "../../configs/endpoints";
import SimpleDialog from "../common/SimpleDialog";
import useOptions from "../../hooks/useOptions";
import { ClaimType } from "../common/RenderIf";
import RecordPermissions from "./RecordPermissions";
import SectionAppBar from "../../v2/components/Section/SectionAppBar";
import SaveButton from "../../v2/components/Button/SaveButton";
import StandardButton from "../../v2/components/Button/StandardButton";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && (
                <Box sx={{ p: 3, height: '100%', maxHeight: '100%', overflowY: 'auto'}}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}


type Props = {
    open: boolean,
    onClose: () => void,
    selectedRoleId: string
}

const EditRoleDrawer = ({ open, onClose, selectedRoleId }: Props) => {
    const [rolePermissions, setRolePermissions] = useState({} as RolePermission)
    const [nameError, setNameError] = useState(false);
    const { options: sprints } = useOptions('sprint');
    const { options: customers } = useOptions('customers');

    const [value, setValue] = useState(0);

    useEffect(() => {
        const loadPermissions = async () => {
            if (isEmpty(selectedRoleId)) {
                setRolePermissions({} as RolePermission);
                return;
            }

            const response = await client.get(rolePermissionsEndpoint.replace('{id}', selectedRoleId))
            setRolePermissions(response.data);
        }

        loadPermissions();
    }, [selectedRoleId])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const toggleAdmin = async () => {
        var temp = cloneDeep(rolePermissions);

        //temp.modules.forEach(module => {
        //    module.permissions.forEach(permission => {
        //        permission.selected = !temp.isAdmin;
        //    })
        //})

        temp.isAdmin = !temp.isAdmin;

        setRolePermissions(temp);
    }


    const updateModuleClaim = async (moduleId: string, permissionId: string, status: boolean) => {
        var temp = cloneDeep(rolePermissions);

        const module = temp.modules.find(m => m.id === moduleId);

        if (module) {
            const perm = module.permissions.find(p => p.id === permissionId);

            if (perm) {
                perm.selected = status;
            }
        }

        setRolePermissions(temp);
    }

    const isRecordChecked = (claimType: ClaimType, value: string) => {
        if (!rolePermissions.modules) return false;

        const module = rolePermissions.modules.find(m => m.claimType == claimType);

        if (module) {
            return module.recordPermissions.some(rp => rp.claimValue === value && rp.isActive);
        }

        return false;
    }

    const updateRecordClaim = async (recordId: string, claimType: ClaimType, status: boolean) => {
        const temp = cloneDeep(rolePermissions);

        const module = temp.modules.find(m => m.claimType == claimType);

        if (module) {
            const recordIndex = module.recordPermissions.findIndex(rp => rp.claimValue === recordId);

            if (recordIndex > -1) {
                module.recordPermissions[recordIndex].isActive = status;
            } else
                module.recordPermissions.push({
                    claimType: module.claimType,
                    claimValue: recordId,
                    isActive: true
                });
        }

        setRolePermissions(temp);
    }

    const onChangeRoleName = (roleName: string) => {
        var temp = cloneDeep(rolePermissions);

        temp.name = roleName;

        setRolePermissions(temp);
    }

    const onSubmit = async () => {
        var response = await client.put('/api/admin/roles', rolePermissions);
        console.log(response);
        onClose();
    }
    console.log(rolePermissions.name)

    const renderPermissions = (m: PermissionModule, mIndex: number) => {
        const groups = [...new Set(m.permissions.sort((a, b) => {
            if (a.groupSortOrder < b.groupSortOrder) return -1;
            if (a.groupSortOrder > b.groupSortOrder) return 1;
            return 0;
        }).map((item) => item.groupName))];

        var nodes = [] as ReactNode[];

        groups.forEach(grp => {
            const permissions = m.permissions.filter(s => s.groupName == grp).sort((a, b) => {
                if (a.groupSortOrder < b.groupSortOrder) return -1;
                if (a.groupSortOrder > b.groupSortOrder) return 1;
                return 0;
            });

            nodes.push(
                <TableRow key={mIndex} sx={{ '& .MuiTableCell-root:first-of-type': { pl: 0 } }}>
                    <TableCell sx={{ fontWeight: 600, color: theme => `${theme.palette.text.primary} !important`, verticalAlign: 'top' }} style={{ width: 1, whiteSpace: 'nowrap' }}>
                        {grp}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'left' }}>
                        {permissions.map((permission, permissionIndex: number) => <FormControlLabel key={`${mIndex}-${permissionIndex}`} control={<Checkbox size='small' checked={permission.selected} onChange={(e) => updateModuleClaim(m.id, permission.id, e.target.checked)} />} label={permission.name} />)}
                    </TableCell>
                </TableRow>
            )
        })

        return nodes;
    }

    if (!rolePermissions.modules) return null;


    return (
        <SimpleDialog
            open={open}
            onClose={onClose}
            padding={0}
            fullHeight={false}
            size='lg'
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <SectionAppBar
                            title={`Edit Role: ${rolePermissions.name}`}
                            subTitle={''}
                            buttons={
                                <>
                                    <SaveButton size='small' type='submit' variant='contained' onClick={onSubmit} icon={<SaveAltIcon />}>
                                        Save
                                    </SaveButton>
                                    <StandardButton size='small' variant='outlined' color='secondary' onClick={onClose} icon={<CloseIcon />}>
                                        Cancel
                                    </StandardButton>
                                </>
                            }
                        />


                    </Box>
                </Box>
                <Box display='flex' justifyContent='flex-end'>
                    <Box
                        sx={{
                            display: 'flex',
                            fontSize: '0.875rem',
                            alignItems: 'center',
                            textTransform: 'capitalize',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        Administrator Access
                        <Tooltip placement='top' title='Allows a full access to the system'>
                            <InformationOutline sx={{ ml: 1, fontSize: '1rem' }} />
                        </Tooltip>
                    </Box>
                    <FormControlLabel
                        label=''
                        key={rolePermissions.name}
                        control={<Checkbox size='small' checked={rolePermissions.isAdmin} onChange={toggleAdmin} />}
                        sx={{ '& .MuiTypography-root': { textTransform: 'capitalize', whiteSpace: 'nowrap' } }}
                    />
                </Box>
                <Box>
                    <Box
                        sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '70vh', maxHeight: '70vh' }}
                    >
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            sx={{ borderRight: 1, borderColor: 'divider', width: 280 }}
                        >
                            {rolePermissions.modules.map((m, mIndex) => <Tab label={m.name} {...a11yProps(mIndex)} style={{ width: 200, whiteSpace: 'nowrap' }} />)}
                        </Tabs>
                        {rolePermissions.modules.map((m, mIndex) => <TabPanel value={value} index={mIndex}>
                            <TableContainer sx={{ maxHeight: '100%', overflowY: 'auto' }}>
                                <TableContainer sx={{ maxHeight: '100%' }}>
                                    <Table size='small' sx={{ width: '100%' }} stickyHeader>
                                        <TableBody>
                                            {renderPermissions(m, mIndex)}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TableContainer>

                            {m.restrictRecords && <RecordPermissions optionType={m.optionType} isRecordChecked={isRecordChecked} updateRecordClaim={updateRecordClaim} claimType={m.claimType} />}
                        </TabPanel>)}
                    </Box>
                </Box>
            </Box>




        </SimpleDialog>
    )
}

export default EditRoleDrawer;